import { render, staticRenderFns } from "./OrderDetailForm.vue?vue&type=template&id=01e8f784&"
import script from "./OrderDetailForm.ts?vue&type=script&lang=js&"
export * from "./OrderDetailForm.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports